<template>
  <b-navbar v-if="currentUser" class="mx-auto px-0" style="max-width: 1200px">
    <b-navbar-brand href="#" :to="{ name: 'App' }" style="margin-left: -20px">
      <img :src="require('@/assets/horizontal_logo2.png')" alt="VaWorks Live" width="200">
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-navbar-nav>
          <b-nav-item href="#" :to="{ name: 'AdminDashboard' }" v-if="currentUser.roles.includes('Administrator')" active-class="active">Administrator</b-nav-item>
          <b-nav-item href="#" :to="{ name: 'SalesDashboard' }" v-if="currentUser.roles.includes('Sales')" active-class="active">Sales Dashboard</b-nav-item>
          <b-nav-item href="#" :to="{ name: 'Quotes' }" v-if="currentUser.roles.includes('User')" active-class="active">Quote History</b-nav-item>
          <b-nav-item href="#" :to="{ name: 'Configure' }" v-if="currentUser.roles.includes('User')" active-class="active">Create RFQ</b-nav-item>
          <message-view></message-view>
        </b-navbar-nav>

        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em>My Account</em>
          </template>
          <b-dropdown-item href="#" :to="{ name: 'Profile' }" :userId="currentUser.id" v-if="currentUser.roles.includes('User')">Profile</b-dropdown-item>
          <expedite-fee-calculator v-if="currentUser.roles.includes('Sales')"></expedite-fee-calculator>
          <b-dropdown-item href="#" @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import MessageView from '../../admin/messages/components/MessageView.vue'
import ExpediteFeeCalculator from '../../app/ExpediteFeeCalculator.vue'

export default {
  data () {
    return { }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  components: {
    MessageView,
    ExpediteFeeCalculator
  }
}
</script>

<style>
  .user-dropdown {
    min-width: 0%
  }
</style>



// WEBPACK FOOTER //
// src/views/layouts/components/NavBar.vue